export default function Accolades() {
  const certificates = [
    { src: "/img/aws-practitioner.png", label: "AWS Cloud Practitioner" },
    { src: "/img/aws-saa.png", label: "AWS Solutions Architect Associate" },
    { src: "/img/aws-sap.png", label: "AWS Solutions Architect Professional" },
    { src: "/img/aws-developer.png", label: "AWS Developer Associate" },
    { src: "/img/aws-sysops.png", label: "AWS SysOps Associate" },
    { src: "/img/aws-security.png", label: "AWS Security Specialty" },
    { src: "/img/AI Practitioners.png", label: "AI Practitioners" },
    { src: "/img/DevOps Engineer.png", label: "DevOps Engineer" },
    { src: "/img/terraform.png", label: "Terraform Expert" },
  ];

  return (
    <section className="certificate-section" id="certifications">
      <div className="portfolio-container-box">
        <div className="portfolio-container">
          <h2 className="skills-section-heading">Certifications</h2>
          <p className="cert-section-subtext">
            Validated expertise across AWS and Infrastructure as Code.
          </p>
        </div>
      </div>

      {/* Desktop/tablet grid */}
      <div className="certificates-desktop">
        <ul
          className="certificate-container"
          role="list"
          aria-label="Certification badges"
        >
          {certificates.map((c) => (
            <li className="cert-card" key={c.label}>
              <a
                className="cert-link"
                href="https://www.credly.com/users/nsuku-mathebula"
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`${c.label} – view on Credly`}
              >
                <img src={c.src} alt={c.label} />
                <span className="cert-label">{c.label}</span>
              </a>
            </li>
          ))}
        </ul>
      </div>

      {/* Mobile marquee (right-to-left) */}
      <div className="certificates-mobile-marquee" aria-hidden="false">
        <div className="certificate-marquee" role="region" aria-label="Certification badges carousel">
          <ul className="certificate-track" role="list">
            {certificates.map((c) => (
              <li className="cert-card" key={`m1-${c.label}`}>
                <a
                  className="cert-link"
                  href="https://www.credly.com/users/nsuku-mathebula"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`${c.label} – view on Credly`}
                >
                  <img src={c.src} alt={c.label} />
                  <span className="cert-label">{c.label}</span>
                </a>
              </li>
            ))}
          </ul>
          <ul className="certificate-track" role="list" aria-hidden="true">
            {certificates.map((c) => (
              <li className="cert-card" key={`m2-${c.label}`}>
                <a
                  className="cert-link"
                  href="https://www.credly.com/users/nsuku-mathebula"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`${c.label} – view on Credly`}
                >
                  <img src={c.src} alt={c.label} />
                  <span className="cert-label">{c.label}</span>
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
